<div class="rating">
  <span
    (click)="onRatingClicked(rating)"
    *ngFor="let rating of ratingArray"
    [class.readonly]="readonly"
    [class.selected]="rating <= selectedRating"
    class="star">&#9733;</span>
</div>
